import { saveChrisStrategy } from '../../../service/saveChrisStrategy';
import { createAction } from 'redux-act';
import groupBy from 'lodash/groupBy';
import flatMap from 'lodash/flatMap';

import { isEmpty } from 'lodash';
import {
  teamPlayerList,
  teamPlayerListLoan,
  teamStrategy,
  teamSquad,
} from '../../../service/links';
import {
  sendReleaseRequest,
  sendAutoFormationRequest,
  setCaptain,
} from '../../../api/team';
import { captainErrorCopy } from '../../../service/captain';
import { getPlayerInfo, getPlayerCareer } from '../../../api/league';
import { clubStayFromCareer } from '../../../service/playerStats';
import {
  boostRequest,
  delayDeclineRequest,
  addNicknameRequest,
  setToAcademy,
} from '../../../api/player';
import { POPUPS } from '../../../service/constants';
import { toastRender } from '../../../service/toaster';
import { readAutoFormationEnabled } from '../../../service/autoFormationFlag';
import { sidebarGetDataForSideBar } from '../Sidebar';
import { setErrorToPopup, isPopupLoading, showPopupWindow } from '../Popups';
import { getTasksList } from '../Tasks';
import { trackSetTeam } from '../../../service/analytics';
import { isMatchLive } from '../../../service/liveMatch';
import { lineupRefusedCopy } from '../../../service/availability';

const {
  CONFIRM_ACCELERATE_POPUP,
  CONFIRM_DECLINE_DELAY_POPUP,
  ADD_NICKNAME_POPUP,
  RELEASE_PLAYER_POPUP,
  CONFIRM_ACADEMY_POPUP,
} = POPUPS;
const generalTeamRool = {
  '4-4-2': {
    LS: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RS: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    GK: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
  },
  '4-3-3': {
    LW: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    CF: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RW: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DM(C)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    GK: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
  },
  '4-2-3-1': {
    CF: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    CM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    // CAM: [
    //   {
    //     name: "Empty",
    //     rating: "0",
    //   },
    // ],
    RM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DM(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DM(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    GK: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
  },
  '4-5-1': {
    CF: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],

    'DM(C)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    GK: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
  },
  '3-5-2': {
    LS: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RS: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    // CAM: [
    //   {
    //     name: "Empty",
    //     rating: "0",
    //   },
    // ],
    CM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],

    'DM(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DM(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(C)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    GK: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
  },
  '4-4-1-1': {
    CF: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    LCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    CM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    // CAM: [
    //   {
    //     name: "Empty",
    //     rating: "0",
    //   },
    // ],
    RCM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RM: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],

    LB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(L)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    'DC(R)': [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    RB: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
    GK: [
      {
        name: 'Empty',
        rating: '0',
      },
    ],
  },
};

export const addToList = createAction('add player to sidebar view list');
export const loadPlayerInfo = createAction('add player loading');
export const removeFromList = createAction(
  'remove player from sidebar view list'
);
export const setUnsavedChanges = createAction('Unsaved changes added');

export const teamAddToList = (data) => async (dispatch) => {
  dispatch(loadPlayerInfo());
  const [playerDataResponse, careerResponse] = await Promise.all([
    getPlayerInfo(data._id),
    getPlayerCareer(data._id).catch(() => null),
  ]);
  if (playerDataResponse.status !== 200) {
    dispatch(addToList({ player: null }));
    return;
  }
  const playerData = await playerDataResponse.json();
  let clubStay = null;
  try {
    if (careerResponse?.status === 200) {
      clubStay = clubStayFromCareer(await careerResponse.json());
    }
  } catch {
    clubStay = null;
  }
  const apiPlayer = playerData.players || {};
  const row = Object.fromEntries(
    Object.entries(data || {}).filter(([, value]) => value !== undefined)
  );
  const {
    recovery_time,
    fav_formation,
    fav_style,
    fav_mindset,
    fav_opponent,
    fav_zone,
    worst_mindset,
    worst_opponent,
    second_fav_position,
    transfer_feeling,
    rating_range,
  } = apiPlayer;
  const firstName = row.first_name || apiPlayer.first_name || '';
  const lastName = row.last_name || apiPlayer.last_name || '';
  const player = {
    ...apiPlayer,
    ...row,
    recovery_time,
    first_name: firstName,
    last_name: lastName,
    name: row.name || apiPlayer.name || `${firstName} ${lastName}`.trim(),
    teamName:
      row.teamName ||
      row.team?.name ||
      apiPlayer.teamName ||
      apiPlayer.team?.name,
    fav_formation,
    fav_style,
    fav_mindset,
    fav_opponent,
    fav_zone,
    worst_mindset,
    worst_opponent,
    second_fav_position,
    transfer_feeling,
    contract: playerData.contract,
    rating_range: rating_range ?? row.rating_range,
    media_rating: row.media_rating || apiPlayer.media_rating || [],
    previous_rating: row.previous_rating || apiPlayer.previous_rating || [],
    clubStay,
  };
  dispatch(addToList({ player }));
};
export const teamRemoveFromList = (player) => async (dispatch) => {
  dispatch(removeFromList({ player }));
};

// ----------------------STRATEGY----------------------------------

export const pickOpponentStrategy = createAction(
  'select strategy for our match for opponent'
);

export const teamPickUpOpponentStrategy = (strategy) => async (dispatch) => {
  dispatch(pickOpponentStrategy({ strategy }));
};

export const pickStrategy = createAction('select strategy for our match');

export const teamPickUpStrategy = (strategy) => async (dispatch, getState) => {
  const {
    team: {
      strategy: { majorStaff, allTeam },
    },
  } = getState();
  const MyTeamGrouped = groupBy(majorStaff, 'current_position');
  const idealTeamConfig = generalTeamRool[strategy];
  const CHECKED = Object.keys(idealTeamConfig).map(
    (teamType) => MyTeamGrouped[teamType]
  );
  // TODO: Need's to remove such a lot of function for testing purposes
  const fromCheckedToGrouped = flatMap(CHECKED);
  const grouped = groupBy(fromCheckedToGrouped, 'id');
  // The reducer keeps sent-off starters on one of these slots.
  const slots = Object.keys(idealTeamConfig);
  const newAll = allTeam.map(({ main, id, ...all }) => {
    if (grouped[id])
      return {
        ...all,
        id,
        main: true,
      };
    return {
      ...all,
      id,
      main: false,
    };
  });
  dispatch(pickStrategy({ strategy, newAll, slots }));
};
export const getOpponentStrategy = createAction(
  'select strategy for our match'
);

export const teamGetOpponentStrategy = (strategy) => async (dispatch) => {
  dispatch(getOpponentStrategy({ strategy }));
};

// -------------------------LIST PLAYER LOGIC---------------------------
export const listPlayerLoader = createAction('list/remove player loader');
export const listPlayer = createAction('list/remove player');
export const listPlayerError = createAction('list/remove player error');
export const teamListPlayer =
  (playerID, listed = true) =>
    async (dispatch) => {
      dispatch(listPlayerLoader());
      const response = await fetch(teamPlayerList, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        credentials: 'include',
        body: JSON.stringify({
          playerID,
          listed,
        }),
      });
      if (response.status === 200) {
        dispatch(listPlayer({ playerID, status: listed }));
        toastRender(
          'success',
          `Player was ${listed
            ? 'added to the transfer list'
            : 'removed from the transfer list'
          }`
        );
      } else {
        dispatch(listPlayerError());
        if (response.status === 403) {
          toastRender('error', 'Player is not in team');
        } else {
          toastRender(
            'error',
            'Red card. We’re having issues with our club platform'
          );
        }
      }
    };

export const teamListPlayerForLoan =
  (playerID, listed = true) =>
    async (dispatch) => {
      dispatch(listPlayerLoader());
      const response = await fetch(teamPlayerListLoan, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        credentials: 'include',
        body: JSON.stringify({
          playerID,
          listed,
        }),
      });
      if (response.status === 200) {
        dispatch(listPlayer({ playerID, status: listed, field: 'listed_loan' }));
        toastRender(
          'success',
          `Player was ${listed
            ? 'added to the loan list'
            : 'removed from the loan list'
          }`
        );
      } else {
        dispatch(listPlayerError());
        if (response.status === 403) {
          toastRender('error', 'Player is not in team');
        } else {
          toastRender(
            'error',
            'Red card. We’re having issues with our club platform'
          );
        }
      }
    };

// -----------------------GET STRATEGY-----------------------
export const getMyStrategyLoading = createAction(
  'set loading state for getting information about my own strategy'
);
export const getMyStrategy = createAction(
  'get information about my own strategy'
);
export const teamGetMyStrategy = () => async (dispatch, getState) => {
  dispatch(getMyStrategyLoading());
  const response = await fetch(teamStrategy, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    credentials: 'include',
  });
  if (response.status === 200) {
    const formationDescription = {
      0: '4-4-2',
      1: '4-3-3',
      2: '4-2-3-1',
      3: '4-5-1',
      4: '3-5-2',
      5: '4-4-1-1',
    };
    const data = await response.json();
    const {
      teamPlayers,
      opponentPlayers,
      teamFormation,
      opponentName,
      opponentLastFormation,
      tactics,
      upcomingCalender,
      matchRunning,
      discordChannel,
      isOpponentPremium,
      teamKit,
      opponentKit,
      captain,
      formationStyles,
      practiceBoostUntil,
    } = data;
    const isAutoFormationEnabled = readAutoFormationEnabled(data) ?? null;
    const findNotInMainSquad = teamPlayers.find(({ status }) => status === 0);
    const notInMainSquad = findNotInMainSquad
      ? findNotInMainSquad.players.map(({ ...data }) => ({
        ...data,
        main: false,
      }))
      : [];
    const mainSquad = teamPlayers.find(({ status }) => status === 1);
    const inMainSquad =
      mainSquad?.players.map(({ ...data }) => ({ ...data, main: true })) || [];
    const allTeam = [...notInMainSquad, ...inMainSquad];
    dispatch(
      getMyStrategy({
        allTeam,
        notInMainSquad,
        inMainSquad,
        opponentPlayers,
        opponentName,
        teamFormation: formationDescription[teamFormation],
        opponentLastFormation: formationDescription[opponentLastFormation],
        tactics,
        upcomingCalendar: upcomingCalender,
        isAutoFormationEnabled,
        matchRunning,
        discordChannel,
        isOpponentPremium,
        teamKit,
        opponentKit,
        // Feature detection: from the Match Engine 2.5 deploy on, GET /team/strategy always sends
        // `captain` (null when it can't be computed). Absent means today's API.
        hasMatchEngine25: Object.prototype.hasOwnProperty.call(data, 'captain'),
        captain: captain !== undefined ? captain : null,
        formationStyles: formationStyles !== undefined ? formationStyles : null,
        practiceBoostUntil:
          practiceBoostUntil !== undefined ? practiceBoostUntil : null,
        hasCaptainField: Object.prototype.hasOwnProperty.call(data, 'captain'),
        hasFormationStyles: Object.prototype.hasOwnProperty.call(
          data,
          'formationStyles'
        ),
        hasPracticeBoostUntil: Object.prototype.hasOwnProperty.call(
          data,
          'practiceBoostUntil'
        ),
      })
    );
  }
  // GENERATE DATA
  // dispatch(getMyTeam({ all: makeDataTeam(80) }));
};

// The live poll (GET /league/match/:id) answers null until full time, so a red card reaches the
// web only through matchRunning on GET /team/strategy. This re-read stores matchRunning alone, so
// the lineup on the board and any unsaved edits stay as they are.
export const liveStrategyRefreshed = createAction('Live match state re-read from strategy');
export const teamRefreshLiveMatch = () => async (dispatch, getState) => {
  let data;
  try {
    const response = await fetch(teamStrategy, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      credentials: 'include',
    });
    if (response.status !== 200) return;
    data = await response.json();
  } catch {
    return;
  }
  const wasLive = isMatchLive(getState().team.strategy.matchRunning);
  const nextRunning = data?.matchRunning ?? null;
  dispatch(liveStrategyRefreshed({ matchRunning: nextRunning }));
  if (data && 'captain' in data) dispatch(captainUpdated(data.captain));
  // Full time: the backend has taken sent-off and suspended players out of the XI. Reload the
  // board once so it shows that lineup. Halftime can briefly omit matchRunning on strategy —
  // confirm via /home before treating the match as over.
  if (wasLive && !isMatchLive(nextRunning)) {
    try {
      const { homeGetHomeInitialData } = await import('../Home');
      await dispatch(homeGetHomeInitialData());
    } catch {
      /* fall through to strategy reload */
    }
    const homeRunning = getState()?.home?.data?.matchRunning;
    if (isMatchLive(homeRunning)) {
      dispatch(liveStrategyRefreshed({ matchRunning: homeRunning }));
      return;
    }
    await dispatch(teamGetMyStrategy());
  }
};

// -----------------------CAPTAIN (Match Engine 2.5)-----------------------
export const captainUpdated = createAction('Captain block updated');

// Re-read the captain block alone; the board's lineup stays as it is. The preview describes the
// saved XI, so it changes after a lineup save.
export const teamRefreshCaptain = () => async (dispatch) => {
  try {
    const response = await fetch(teamStrategy, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      credentials: 'include',
    });
    if (response.status !== 200) return;
    const data = await response.json();
    if (data && 'captain' in data) dispatch(captainUpdated(data.captain));
  } catch {
    // Keep the current block; the next strategy load refreshes it.
  }
};

// POST /team/captain. Resolves true when the pick was saved.
export const teamSetCaptain = (playerID) => async (dispatch) => {
  let response;
  try {
    response = await setCaptain(playerID);
  } catch {
    toastRender('error', captainErrorCopy());
    return false;
  }
  // The 403 for a player who isn't at the club has no JSON body.
  const body = await response.json().catch(() => null);
  if (response.status === 200) {
    if (body && 'captain' in body) dispatch(captainUpdated(body.captain));
    else dispatch(teamRefreshCaptain());
    const name = body?.captain?.player?.name;
    toastRender('success', name ? `${name} is your captain.` : 'Captain updated.');
    return true;
  }
  toastRender('error', captainErrorCopy(response.status, body?.reason));
  // A 409 means the change state moved on (a match started, or the season's change was used).
  if (response.status === 409) dispatch(teamRefreshCaptain());
  return false;
};

// -------------------MAKE REQUEST FOR CREATING MATCH-------------
export const createRequestForSaveStrategy = createAction(
  'make request for save strategy'
);
export const setRequestForSaveStrategyLoading = createAction(
  'make request for save strategy loading'
);
export const updateStrategyData = createAction('update strategy data');
export const teamCreateRequestForSaveStrategy =
  (effort, mindset, teamTYPE, soccerTeam, matchRunning) => async (dispatch, getState) => {
    dispatch(setRequestForSaveStrategyLoading());
    const formationDescription = {
      '4-4-2': 0,
      '4-3-3': 1,
      '4-2-3-1': 2,
      '4-5-1': 3,
      '3-5-2': 4,
      '4-4-1-1': 5,
    };

    const formation = formationDescription[teamTYPE];
    const players = soccerTeam.map(({ _id, current_position }) => ({
      _id,
      pos: current_position,
    }));
    const delegateFlag = getState().team?.strategy?.isAutoFormationEnabled;
    const isAutoFormationEnabled = typeof delegateFlag === 'boolean' ? delegateFlag : undefined;
    const response = await fetch(teamStrategy, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      credentials: 'include',
      body: JSON.stringify({
        effort,
        mindset,
        formation,
        players,
        isAutoFormationEnabled,
      }),
    });
    if (response.status === 200) {
      trackSetTeam({ formation });
      dispatch(
        createRequestForSaveStrategy({
          formation,
          players,
          competeLoading: true,
        })
      );
      dispatch(getTasksList());
      // Refresh so captain preview and sent-off state match the saved XI.
      dispatch(teamGetMyStrategy());
      toastRender(
        'success',
        `${matchRunning
          ? 'You got it boss. We’ll make these changes as soon as possible and hopefully win this match.'
          : 'Strategy submitted. We’ll brief the players.'
        } `
      );
    } else {
      dispatch(
        createRequestForSaveStrategy({
          formation,
          players,
          competeLoading: false,
        })
      );
      if (response.status === 403) {
        // The server refused this lineup (it answers 403 today too, for example for a player who
        // left the club). Name suspended / missing sent-off players when the board can tell.
        toastRender(
          'error',
          lineupRefusedCopy(soccerTeam, getState().team?.strategy)
        );
        dispatch(teamGetMyStrategy());
      } else {
        toastRender(
          'error',
          'Red card. We’re having issues with our club platform'
        );
      }
    }
  };

export const setStrategyCaptain = createAction('set strategy captain block');

// Strategy UI entry point (Captain panel + right-click Make captain). Same POST as
// teamSetCaptain; must not reload /team/strategy or unsaved lineup edits are wiped.
export const setTeamCaptain = (playerID) => async (dispatch) => {
  const ok = await dispatch(teamSetCaptain(playerID));
  return { ok };
};
// -----------------------TEAM---------------------------
export const setSeason = createAction('Set season number');
export const setSeasonNumber = (number) => async (dispatch) => {
  dispatch(setSeason(number));
};

export const getMyTeamLoading = createAction(
  'set loading state for getting information about my own team'
);
export const getMyTeam = createAction('get information about my own team');
export const teamGetMyTeam = () => async (dispatch) => {
  dispatch(getMyTeamLoading());
  const response = await fetch(teamSquad, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    credentials: 'include',
  });
  if (response.status === 200) {
    const {
      players,
      loanedOutPlayers = [],
      seasonNumber,
      academyPlayers,
    } = await response.json();
    const formattedLoanedOutPlayers = loanedOutPlayers.map((obj) => ({
      ...obj,
      loanedOut: true,
    }));
    const allPlayers = [
      ...players,
      ...formattedLoanedOutPlayers,
      ...academyPlayers,
    ];
    const academyFormattedPlayers = academyPlayers.map((player) => player._id);
    dispatch(setSeasonNumber(seasonNumber));
    dispatch(
      getMyTeam({
        allPlayers,
        academyList: academyFormattedPlayers,
        academyPlayers,
      })
    );
  }
};
export const removePlayerFromMajorStaff = createAction(
  'Player was removed from major staff'
);
export const removePlayerFromStaff = (id) => async (dispatch) => {
  dispatch(removePlayerFromMajorStaff(id));
  dispatch(setUnsavedChanges(true));
};
// ----------------------EXPERT TIPS-----------------------------------------

export const showExpertTips = createAction('show expert tips');
export const teamShowExpertTips = (state) => async (dispatch) => {
  dispatch(showExpertTips({ state }));
};
// ---------------------REPLACE PLAYER-------------------------------------

export const selectPlayerOnGameField = createAction(
  'select player on game field'
);
export const teamSelectPlayerOnGameField = (player) => async (dispatch) => {
  dispatch(selectPlayerOnGameField({ player }));
};
export const replacePlayerFromTheirPosition = createAction(
  'replace player from their position'
);
export const clickedPitchPlayerPosition = createAction(
  'player position on pitch click'
);
export const teamReplacePlayerFromTheirPosition =
  (player) => async (dispatch) => {
    dispatch(replacePlayerFromTheirPosition({ player }));
    dispatch(setUnsavedChanges(true));
  };
export const pitchPlayerPosition = (position) => async (dispatch) => {
  dispatch(clickedPitchPlayerPosition(position));
};

// -------------------RELEASE PLAYER -------------------------------
export const releasePlayerLoading = createAction('Release request loading');
export const sendReleasePlayer = (playerID) => async (dispatch) => {
  dispatch(isPopupLoading(RELEASE_PLAYER_POPUP, true));
  const response = await sendReleaseRequest(playerID);
  if (response.status === 200) {
    dispatch(sidebarGetDataForSideBar());
  } else {
    // TODO create mapping for statuses from separate file
    let error;
    if (response.status === 410) {
      error = {
        header: 'Can’t release this player',
        text: 'Our agreement with the players prevents clubs from releasing Strong players aged 34 and under, World Class players 36 and under, and Legend players 38 and under. Try to sell them instead.',
      };
    } else if (response.status === 411) {
      error = {
        header: 'Unable to release player',
        text: ' Teams are not allowed to release players during matches. Try again later.',
      };
    } else {
      error = {
        header: 'There is some server error.',
        text: 'Please try again later.',
      };
    }
    dispatch(setErrorToPopup(RELEASE_PLAYER_POPUP, error));
  }
  dispatch(isPopupLoading(RELEASE_PLAYER_POPUP, false));
};

export const removePlayer = createAction('Player was removed from team table');

export const removeReleasedPlayer = (playerID) => async (dispatch) => {
  dispatch(removePlayer(playerID));
};
export const setMindset = createAction('Set mindset');
export const setTactic = createAction('Set tactic');
export const setEffort = createAction('Set effort');
export const setTacticData = (data) => async (dispatch) => {
  dispatch(setTactic(data));
};
export const setMindsetData = (data) => async (dispatch) => {
  dispatch(setMindset(data));
  dispatch(setUnsavedChanges(true));
};
export const setEffortData = (data) => async (dispatch) => {
  dispatch(setEffort(data));
  dispatch(setUnsavedChanges(true));
};

export const setSelectedListIds = createAction(
  'Set selected strategy players ids'
);
export const setSelectedTeamIds = (list) => async (dispatch) => {
  dispatch(setSelectedListIds({ list }));
};

export const setAutoFormationVal = createAction('Set auto formation value');
export const setAutoFormationValue = (val) => async (dispatch) => {
  dispatch(setAutoFormationVal(val));
};

export const autoFormationLoading = createAction('Start auto format loading');
export const setAutoFormationList = createAction('Start auto format loaded');

const parseAutoFormation = (autoFormation) => {
  const findNotInMainSquad = autoFormation.find(({ status }) => Number(status) === 0);
  const notInMainSquad = findNotInMainSquad
    ? findNotInMainSquad.players.map(({ ...data }) => ({
      ...data,
      main: false,
    }))
    : [];
  const mainGroup = autoFormation.find(({ status }) => Number(status) === 1);
  const inMainSquad = mainGroup
    ? mainGroup.players.map(({ ...data }) => ({ ...data, main: true }))
    : [];
  return {
    allTeam: [...notInMainSquad, ...inMainSquad],
    inMainSquad,
    notInMainSquad,
  };
};

const lineupGroupsFrom = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.teamPlayers)) return payload.teamPlayers;
  if (Array.isArray(payload?.autoFormation)) return payload.autoFormation;
  if (Array.isArray(payload?.players) && payload.status != null) {
    return [payload];
  }
  return [];
};

let fillChrisInFlight = false;

const syncDelegateStatus = async (dispatch, confirmedFallback = null) => {
  // Re-read the server; a requested value or a browser cache is not confirmation.
  let enabled = confirmedFallback;
  try {
    const response = await fetch(teamStrategy, { credentials: 'include' });
    if (response.status === 200) enabled = readAutoFormationEnabled(await response.json()) ?? confirmedFallback;
  } catch { /* Keep an unknown status instead of displaying a stale On state. */ }
  dispatch(setAutoFormationVal(enabled));
  return enabled;
};

// Legacy API contract: squad groups mean On; an empty object (or array) means Off.
// This endpoint toggles delegation, it does not provide a stateless lineup preview.
const readChrisResponse = async (response) => {
  if (response.status !== 200) throw new Error('Chris request failed');
  const payload = await response.json();
  const groups = lineupGroupsFrom(payload);
  const hasLineup = groups.some((group) => Number(group?.status) === 1 && Array.isArray(group.players) && group.players.length > 0);
  const isEmptyReply = payload !== null && typeof payload === 'object' &&
    Object.keys(payload).length === 0;
  const enabled = readAutoFormationEnabled(payload) ??
    (hasLineup ? true : isEmptyReply ? false : null);
  if (enabled === null) throw new Error('Unrecognized Chris response');
  return { groups, hasLineup, enabled };
};

const saveChrisLineup = async (groups, strategyFormat, delegate, dispatch, getState) => {
  const lineup = parseAutoFormation(groups);
  dispatch(setAutoFormationList(lineup));
  dispatch(autoFormationLoading(true));
  dispatch(setUnsavedChanges(true));
  const stateToSave = getState().team.strategy;
  await saveChrisStrategy({
    formation: strategyFormat,
    tactics: stateToSave.tactics,
    players: lineup.inMainSquad,
    delegate,
  });
  const current = getState().team.strategy;
  // Preserve the dirty marker if the user edited the team while saving.
  if (current.majorStaff === stateToSave.majorStaff &&
      current.tactics === stateToSave.tactics &&
      current.currentStrategy === stateToSave.currentStrategy) {
    dispatch(setUnsavedChanges(false));
    dispatch(createRequestForSaveStrategy({ competeLoading: true }));
  }
};

export const setAutoFormation = (strategyFormat) => async (dispatch, getState) => {
  if (fillChrisInFlight) return;
  fillChrisInFlight = true;
  dispatch(autoFormationLoading(true));
  let confirmed = null;
  try {
    const result = await readChrisResponse(await sendAutoFormationRequest(strategyFormat));
    confirmed = result.enabled;
    if (result.hasLineup) {
      await saveChrisLineup(result.groups, strategyFormat, confirmed, dispatch, getState);
    }
    confirmed = await syncDelegateStatus(dispatch, confirmed);
    toastRender('success', confirmed
      ? 'Chris will pick your starting 11 after each match.'
      : 'Chris won’t pick a starting lineup anymore.');
  } catch {
    await syncDelegateStatus(dispatch, confirmed);
    toastRender('error', 'Could not update Delegate to Chris. Please try again.');
  } finally {
    fillChrisInFlight = false;
    dispatch(autoFormationLoading(false));
  }
};

export const fillChrisStartingEleven = (strategyFormat) => async (dispatch, getState) => {
  if (fillChrisInFlight) return;
  fillChrisInFlight = true;
  dispatch(autoFormationLoading(true));
  let confirmed = null;
  let first;
  try {
    const response = await sendAutoFormationRequest(strategyFormat);
    if (response.status === 401 || response.status === 403) {
      dispatch(showPopupWindow(POPUPS.MOBILE_REQUIRED_POPUP, POPUPS.MOBILE_REQUIRED_POPUP));
      return;
    }
    first = await readChrisResponse(response);
    confirmed = first.enabled;
    // Two toggles restore the original server setting. One response contains the XI.
    confirmed = null; // A failed response may still have changed the server.
    const second = await readChrisResponse(await sendAutoFormationRequest(strategyFormat));
    confirmed = second.enabled;
    if (second.enabled === first.enabled) throw new Error('Delegate state was not restored');
    const lineup = first.hasLineup ? first : second;
    if (!lineup.hasLineup) throw new Error('No starting eleven returned');
    await saveChrisLineup(lineup.groups, strategyFormat, confirmed, dispatch, getState);
    toastRender('success', 'Chris selected and saved your starting 11.');
  } catch {
    toastRender('error', first
      ? 'Chris could not finish. Please check Delegate to Chris before trying again.'
      : 'Chris could not pick a starting 11. Please try again.');
  } finally {
    await syncDelegateStatus(dispatch, confirmed);
    fillChrisInFlight = false;
    dispatch(autoFormationLoading(false));
  }
};
// TODO move mobile sidebar actions to Sidebar
export const showMobileSection = createAction('Show mobile strategy section');
export const showMobileSidebarSection = (value) => async (dispatch) => {
  dispatch(showMobileSection(value));
};

export const setFormationFilter = createAction('Set formation table filter');

export const setFormationListFilter = (value) => async (dispatch) => {
  dispatch(setFormationFilter(value));
};

export const editSelectedPlayerData = createAction('Change team player data');
/* export const accBoostLoading = createAction(
  'Acceleration development request loading'
); */

export const playerAccBoost = (playerId) => async (dispatch) => {
  dispatch(isPopupLoading(CONFIRM_ACCELERATE_POPUP, true));
  const response = await boostRequest(playerId);
  if (response.status === 200) {
    dispatch(
      editSelectedPlayerData({
        id: playerId,
        dataToChange: { boost_enabled: true },
      })
    );
    dispatch(sidebarGetDataForSideBar());
  } else {
    let error;
    if (response.status === 201) {
      error = {
        header: 'Reject failed',
        text: 'Player is not in team.',
      };
    } else if (response.status === 202) {
      error = {
        header: 'Request failed',
        text: 'Player is already in this program.',
      };
    } else if (response.status === 203) {
      error = {
        header: 'Not enough money',
        text: "You don't have enough money to perform this operation",
      };
    } else if (response.status === 404) {
      error = {
        header: 'Request failed',
        text: 'Invalid data',
      };
    } else {
      error = {
        header: 'There is some server error.',
        text: 'Please try again later.',
      };
    }
    dispatch(setErrorToPopup(CONFIRM_ACCELERATE_POPUP, error));
  }
  dispatch(isPopupLoading(CONFIRM_ACCELERATE_POPUP, false));
};

export const playerDelayDecline = (playerId) => async (dispatch) => {
  dispatch(isPopupLoading(CONFIRM_DECLINE_DELAY_POPUP, true));
  const response = await delayDeclineRequest(playerId);
  if (response.status === 200) {
    dispatch(
      editSelectedPlayerData({
        id: playerId,
        dataToChange: { decline_enabled: true },
      })
    );
    dispatch(sidebarGetDataForSideBar());
  } else {
    let error;
    if (response.status === 201) {
      error = {
        header: 'Reject failed',
        text: 'Player is not in team.',
      };
    } else if (response.status === 202) {
      error = {
        header: 'Request failed',
        text: 'Player is already in this program.',
      };
    } else if (response.status === 203) {
      error = {
        header: 'Not enough money',
        text: "You don't have enough money to perform this operation",
      };
    } else if (response.status === 404) {
      error = {
        header: 'Request failed',
        text: 'Invalid data',
      };
    } else {
      error = {
        header: 'There is some server error.',
        text: 'Please try again later.',
      };
    }
    dispatch(setErrorToPopup(CONFIRM_DECLINE_DELAY_POPUP, error));
  }
  dispatch(isPopupLoading(CONFIRM_DECLINE_DELAY_POPUP, false));
};

export const setPlayerNickname = (playerId, nickname) => async (dispatch) => {
  dispatch(isPopupLoading(ADD_NICKNAME_POPUP, true));
  const response = await addNicknameRequest(playerId, nickname);
  if (response.status === 200) {
    dispatch(
      editSelectedPlayerData({
        id: playerId,
        dataToChange: { nick_name: nickname },
      })
    );
  } else {
    let error;
    if (response.status === 201) {
      error = {
        header: 'Reject failed',
        text: 'Player is not in team.',
      };
    } else if (response.status === 202) {
      error = {
        header: 'Request failed',
        text: 'Player already has a nickname',
      };
    } else if (response.status === 203) {
      error = {
        header: 'Nickname is already taken.',
        text: 'Let’s be more creative…',
      };
    } else if (response.status === 404) {
      error = {
        header: 'Request failed',
        text: 'Invalid data',
      };
    } else {
      error = {
        header: 'There is some server error.',
        text: 'Please try again later.',
      };
    }
    dispatch(setErrorToPopup(ADD_NICKNAME_POPUP, error));
  }
  dispatch(isPopupLoading(ADD_NICKNAME_POPUP, false));
};

export const setToAcademyAction = createAction('Show mobile strategy section');

export const setToAcademyRequest = (playerId) => async (dispatch) => {
  dispatch(isPopupLoading(CONFIRM_ACADEMY_POPUP, true));
  const response = await setToAcademy(playerId);
  if (response.status === 200) {
    dispatch(setToAcademyAction(playerId));
  } else {
    let error;
    if (response.status === 201) {
      error = {
        header: 'Cannot send player',
        text: 'Player is already in our academy',
      };
    } else if (response.status === 202) {
      error = {
        header: 'Cannot send player',
        text: 'We do not own this player',
      };
    } else if (response.status === 203) {
      error = {
        header: 'Cannot send player',
        text: 'We can only send players who are still developing',
      };
    } else if (response.status === 204) {
      error = {
        header: 'Cannot send player',
        text: 'Player is lent to another team',
      };
    } else if (response.status === 205) {
      error = {
        header: 'Cannot send player',
        text: 'All our academy slots are full',
      };
    } else if (response.status === 206) {
      error = {
        header: 'Cannot send player',
        text: ' All our academy slots are full. Become a patron to open up one additional slot',
      };
    } else if (response.status === 207) {
      error = {
        header: 'Cannot send player',
        text: "You can't move players to the academy during a match.",
      };
    } else {
      error = {
        header: 'Ooops.',
        text: 'Something is wrong with the portal',
      };
    }
    dispatch(setErrorToPopup(CONFIRM_ACADEMY_POPUP, error));
  }
  dispatch(isPopupLoading(CONFIRM_ACADEMY_POPUP, false));
};
